<div class="lista-pedidos-container">
    <div class="card">
        <p-table [value]="pedidos" [lazy]="true" (onLazyLoad)="listaPedidos($event)" dataKey="id" [styleClass]="'text-sm p-datatable-sm'" [scrollable]="true" scrollHeight="calc(100vh - 12rem)" [paginator]="true" [rows]="rows" [first]="first" [totalRecords]="totalRecords" [paginatorPosition]="'top'" [rowsPerPageOptions]="[10, 25, 50]" paginatorLocale="pt-BR" [paginatorStyleClass]="'paginator-oticom'" [loading]="loading" [loadingIcon]="'null'" [globalFilterFields]="['id', 'paciente', 'os_otica', 'observacao']">
            <ng-template pTemplate="caption">
                    <div *ngIf="isMobile">
                        <p-sidebar [(visible)]="filtro_mobile" position="right" [style]="{ 'width': '70%' }">
                            <ng-template pTemplate="header">
                                <span class="font-semibold text-xl">Filtros</span>
                            </ng-template>
                            <p>
                                <app-filtros-pedidos
                                    [datas]="datas"
                                    [localizacoes]="localizacoes"
                                    [filtros]="filtros"
                                    (filtroAplicado)="aplicarFiltros($event)">
                                </app-filtros-pedidos>
                            </p>
                            
                        </p-sidebar>

                        <div class="formgrid grid m-0">
                            <div class="mt-1 mb-2 col-12">
                                <div class="flex justify-content-end flex-wrap">
                                    <p-button (onClick)="filtro_mobile = !filtro_mobile" label="Filtros" icon="pi pi-filter" />
                                </div>
                            </div>
                        </div>
                    </div>
                  
                    <div *ngIf="!isMobile">
                        <app-filtros-pedidos
                            [datas]="datas"
                            [localizacoes]="localizacoes"
                            [filtros]="filtros"
                            (filtroAplicado)="aplicarFiltros($event)">
                        </app-filtros-pedidos>
                    </div>
                
                <div class="card flex justify-content-center" *ngIf="loading">
                    <p-progressSpinner></p-progressSpinner>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr *ngIf="!loading">
                    <th style="max-width: 5%;">Data</th>
                    <th>Tipo</th>
                    <th>Número</th>
                    <th>Loja</th>
                    <th>Cliente</th>
                    <th>Paciente</th>
                    <th>Vendedor</th>
                    <th>Valor</th>
                    <th>Localização</th>
                    <th>Opções</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pedido>
                <tr *ngIf="!loading" [ngClass]="{'pedido-cancelado': pedido.cancelado==='S'}">
                    <td>{{ pedido.data }}</td>
                    <td>{{ pedido.tipo_pedido_lab === 'LT' ? 'OS' : 'Venda' }}</td>
                    <td>{{ pedido.os_otica ?? '-' }}</td>
                    <td>{{ pedido.loja ?? '-' }}</td>
                    <td>{{ pedido.solicitante ?? '-' }}</td>
                    <td>{{ pedido.paciente ?? '-' }}</td>
                    <td>{{ pedido.nome_vendedor ?? '-' }}</td>
                    <td>{{ pedido.valor ?? '-' }}</td>
                    <td>{{ pedido.status }}</td>
                    <td class="text-center">
                        <div class="flex align-items-center justify-content-center gap-2">
                            <p-button icon="pi pi-eye" (onClick)="visualizarPedido(pedido)"></p-button>
                            <p-button *ngIf="!pedido.aprovado && pedido.loja_id" icon="pi pi-pencil" [routerLink]="['/oticomweb/ordem-de-servico', pedido.loja_id, pedido.id]"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr *ngIf="!loading">
                    <td colspan="10" class="text-center">Nenhum pedido encontrado.</td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="paginatorleft">
                <div *ngIf="!loading">
                    <p-button type="button" label="Filtrar" size="small" (click)="listaPedidos()"></p-button>
                </div>
            </ng-template> -->
            <!-- <ng-template pTemplate="paginatorright">
                <div *ngIf="!loading">
                    <p-button type="button" icon="pi pi-plus" label="Novo" [routerLink]="'../novo-pedido'"></p-button>
                </div>
            </ng-template> -->
        </p-table>
    </div>

    <p-dialog header="Detalhes do pedido" [(visible)]="modalVisualizarPedido" [modal]="true" [style]="{ width: '900px' }" [breakpoints]="{ '960px': '95vw' }" [styleClass]="'dialog-visualizar-pedido'" (onHide)="fecharModalVisualizarPedido()">
        <div class="flex justify-content-center p-4" *ngIf="loadingVisualizarPedido">
            <p-progressSpinner></p-progressSpinner>
        </div>

        <div *ngIf="!loadingVisualizarPedido && pedidoVisualizado" class="visualizar-pedido">
            <div class="secao">
                <div class="campos-grid">
                    <ng-container *ngTemplateOutlet="campo; context: { label: 'Loja', valor: pedidoVisualizado.loja }"></ng-container>
                    <ng-container *ngTemplateOutlet="campo; context: { label: 'Cliente', valor: pedidoVisualizado.solicitante }"></ng-container>
                </div>
            </div>

            <ng-container *ngIf="pedidoVisualizado.tipo_pedido_lab === 'LT'">
                <div class="secao">
                    <h4 class="secao-titulo">Informações da receita</h4>
                    <div class="campos-grid">
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'OS', valor: dadosVisualizacao?.nro_os_loja }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Paciente', valor: (dadosVisualizacao?.Receita?.paciente || pedidoVisualizado.paciente) }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Médico', valor: medicoVisualizado?.nome }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'CRM do Médico', valor: medicoVisualizado?.crm }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Data Receita', valor: (dadosVisualizacao?.Receita?.data_receita ? formatDate(dadosVisualizacao.Receita.data_receita) : null) }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Previsão Entrega', valor: (dadosVisualizacao?.previsao_entrega ? formatDate(dadosVisualizacao.previsao_entrega) : null) }"></ng-container>
                    </div>
                </div>

                <div class="secao" *ngIf="dadosVisualizacao?.Receita as receita">
                    <h4 class="secao-titulo">Receita</h4>
                    <div class="tabela-receita">
                        <table>
                            <thead>
                                <tr>
                                    <th rowspan="2">Olho</th>
                                    <th colspan="4">Longe</th>
                                    <th rowspan="2">Adição</th>
                                    <th colspan="4">Perto</th>
                                    <th rowspan="2">Alt.<br>Pupila</th>
                                    <th colspan="2">Prisma horizontal</th>
                                    <th colspan="2">Prisma vertical</th>
                                </tr>
                                <tr>
                                    <th>Esf.</th>
                                    <th>Cil.</th>
                                    <th>Eixo</th>
                                    <th>DNP</th>
                                    <th>Esf.</th>
                                    <th>Cil.</th>
                                    <th>Eixo</th>
                                    <th>DNP</th>
                                    <th>Valor</th>
                                    <th>Base</th>
                                    <th>Valor</th>
                                    <th>Base</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="olho">OD</td>
                                    <td>{{ receita.longe_esferico_olho_direito || '-' }}</td>
                                    <td>{{ receita.longe_cilindrico_olho_direito || '-' }}</td>
                                    <td>{{ receita.longe_eixo_olho_direito || '-' }}</td>
                                    <td>{{ receita.longe_dnp_olho_direito || '-' }}</td>
                                    <td>{{ receita.adicao_olho_direito || '-' }}</td>
                                    <td>{{ receita.perto_esferico_olho_direito || '-' }}</td>
                                    <td>{{ receita.perto_cilindrico_olho_direito || '-' }}</td>
                                    <td>{{ receita.perto_eixo_olho_direito || '-' }}</td>
                                    <td>{{ receita.perto_dnp_olho_direito || '-' }}</td>
                                    <td>{{ receita.altura_pupila_olho_direito || '-' }}</td>
                                    <td>{{ receita.prisma_valor_horizontal_od || '-' }}</td>
                                    <td>{{ receita.prisma_base_horizontal_od || '-' }}</td>
                                    <td>{{ receita.prisma_valor_vertical_od || '-' }}</td>
                                    <td>{{ receita.prisma_base_vertical_od || '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="olho">OE</td>
                                    <td>{{ receita.longe_esferico_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.longe_cilindrico_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.longe_eixo_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.longe_dnp_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.adicao_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.perto_esferico_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.perto_cilindrico_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.perto_eixo_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.perto_dnp_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.altura_pupila_olho_esquerdo || '-' }}</td>
                                    <td>{{ receita.prisma_valor_horizontal_oe || '-' }}</td>
                                    <td>{{ receita.prisma_base_horizontal_oe || '-' }}</td>
                                    <td>{{ receita.prisma_valor_vertical_oe || '-' }}</td>
                                    <td>{{ receita.prisma_base_vertical_oe || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="secao">
                    <h4 class="secao-titulo">Dados da armação</h4>
                    <div class="campos-grid">
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Tipo de montagem', valor: (dadosVisualizacao?.Receita?.tipo_montagem ? tipoMontagemForm(dadosVisualizacao.Receita.tipo_montagem) : null) }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Ponte', valor: dadosVisualizacao?.Receita?.ponte }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Aro', valor: dadosVisualizacao?.Receita?.aro }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Altura vertical', valor: dadosVisualizacao?.Receita?.mov_alt_vertical }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Diagonal maior', valor: dadosVisualizacao?.Receita?.diagonal_maior }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Diâmetro apurado', valor: dadosVisualizacao?.Receita?.diametro_apurado }"></ng-container>
                        <ng-container *ngTemplateOutlet="campo; context: { label: 'Distância pupilar', valor: dadosVisualizacao?.Receita?.distancia_pupilar }"></ng-container>
                    </div>
                </div>

                <div class="secao">
                    <h4 class="secao-titulo">Observação</h4>
                    <div class="observacao">{{ dadosVisualizacao?.Receita?.observacao || '-' }}</div>
                </div>

                <div class="secao" *ngIf="anexosVisualizados.length">
                    <h4 class="secao-titulo">Anexos</h4>
                    <div class="anexos-grid">
                        <a *ngFor="let anexo of anexosVisualizados" class="anexo-item" [href]="anexo.url" [download]="anexo.nome_arquivo" target="_blank" [title]="anexo.nome_arquivo">
                            <img *ngIf="anexo.isImagem" [src]="anexo.url" [alt]="anexo.nome_arquivo">
                            <i *ngIf="!anexo.isImagem" class="pi pi-file anexo-icone"></i>
                            <span class="anexo-nome">{{ anexo.nome_arquivo }}</span>
                        </a>
                    </div>
                </div>
            </ng-container>

            <div class="secao">
                <h4 class="secao-titulo">Resumo do pedido</h4>
                <p-table [value]="produtosVisualizados" [styleClass]="'p-datatable-sm text-sm'">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Código</th>
                            <th>Item</th>
                            <th>Qtd</th>
                            <th>Olho</th>
                            <th>Valor</th>
                            <th>Desconto</th>
                            <th>Total</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-produto>
                        <tr>
                            <td>{{ produto.codigo }}</td>
                            <td>{{ produto.descricao }}</td>
                            <td>{{ produto.quantidade }}</td>
                            <td>{{ produto.tipo_prod || '-' }}</td>
                            <td>{{ produto.vlr_venda_tratado | currency: 'BRL' }}</td>
                            <td>{{ produto.desc_acresc_porcentagem || 0 }}%</td>
                            <td>{{ produto.vlr_liquido_produto * produto.quantidade | currency: 'BRL' }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7" class="text-center">Nenhum item encontrado.</td>
                        </tr>
                    </ng-template>
                </p-table>

                <div class="resumo-totais">
                    <div class="resumo-totais-item">
                        <span>Qtde de itens</span>
                        <strong>{{ totalItensVisualizados() }}</strong>
                    </div>
                    <div class="resumo-totais-item">
                        <span>Valor total</span>
                        <strong>{{ valorTotalVisualizado() | currency: 'BRL' }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #campo let-label="label" let-valor="valor">
            <div class="campo">
                <label>{{ label }}</label>
                <div class="campo-valor">{{ valor || '-' }}</div>
            </div>
        </ng-template>

        <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" label="Fechar" (click)="fecharModalVisualizarPedido()"></p-button>
        </ng-template>
    </p-dialog>
</div>